module.exports = __webpack_public_path__ + "static/anoop_raveendran-50b0ae379c63640037b346e1c51ea04a.jpg";